import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BASE_FONT_COLOR } from 'HubStyleTokens/theme';
import { FONT_FAMILIES, setFontSmoothing } from '../utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLabel = styled.div.withConfig({
  displayName: "UIWellLabel__StyledLabel",
  componentId: "sc-1557bv6-0"
})(["font-size:12px;", ";", ";color:", ";line-height:normal;text-transform:uppercase;margin-bottom:4px;"], FONT_FAMILIES.demibold, setFontSmoothing(), BASE_FONT_COLOR);
const UIWellLabel = props => /*#__PURE__*/_jsx(StyledLabel, Object.assign({}, props));
UIWellLabel.propTypes = {
  children: PropTypes.node
};
UIWellLabel.displayName = 'UIWellLabel';
export default UIWellLabel;